var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserModel } from './user.model';
var psd;
var CustomerModel = /** @class */ (function (_super) {
    __extends(CustomerModel, _super);
    function CustomerModel(data) {
        var _this = _super.call(this) || this;
        _this.country = data.country;
        _this.created = data.created;
        _this.currency = data.currency;
        if (data.devices)
            _this.devices = data.devices;
        _this.displayName = data.displayName;
        _this.email = data.email;
        if (data.firstOrder)
            _this.firstOrder = data.firstOrder;
        _this.language = data.language;
        _this.phone = data.phone;
        if (data.referredBy)
            _this.referredBy = data.referredBy;
        _this.role = data.role;
        _this.status = data.status;
        _this.stpID = data.stpID;
        if (data.uid)
            _this.uid = data.uid;
        if (data.promoCode)
            _this.promoCode = data.promoCode;
        if (data.orders)
            _this.orders = data.orders;
        if (data.pictureURL)
            _this.pictureURL = data.pictureURL;
        psd = data.password;
        _this.giveaway = data.giveaway;
        return _this;
    }
    CustomerModel.prototype.passwordCheck = function (hash) {
        return hash == psd;
    };
    return CustomerModel;
}(UserModel));
export { CustomerModel };
